import mappingPluginBuilder from "lib/mapping/sources/resolver";
import userStore from "data/userStore";
import EntityName from "data/util/EntityName";

const CROSS_APP_KEY = "cross-app";

export const getMappingPlugins = (activeRecord, fluxContext) => {
    const sources = activeRecord.entityInfo.mappingSources;
    if (sources == null) return [];

    return filterSources(activeRecord, sources).map(s => mappingPluginBuilder(s.pluginKey, {
        activeRecord,
        fluxContext,
        mapping: s,
        org: userStore.getActiveOrgKey(),
    }));
};

function filterSources(activeRecord, sources) {
    let allowedSources = sources;
    if (!hasCrossAppMappingPermission(activeRecord)) {
        allowedSources = sources.filter(s => s.pluginKey !== CROSS_APP_KEY);
    }

    return allowedSources;
}

function hasCrossAppMappingPermission(activeRecord){
    const implKey = activeRecord && activeRecord.entityKey ? new EntityName(activeRecord.entityKey).implKey : false;
    if(!implKey) {
        return false;
    }
    return userStore.canCrossAppMap(implKey);
}




// WEBPACK FOOTER //
// ./app/data/selectors/entities.js